/** 업로드 검증 한계 — backend 와 동기화 (config.MAX_UPLOAD_SIZE_MB / MAX_FILES_PER_JOB). */
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_FILES_PER_JOB = 500;

/** M25 — ZIP 업로드(의뢰) 상한. backend config.MAX_ZIP_SIZE_MB 와 동기화. */
export const MAX_ZIP_SIZE_MB = 500;
export const MAX_ZIP_SIZE_BYTES = MAX_ZIP_SIZE_MB * 1024 * 1024;

/** 파일 크기 사람-친화 표기 (예: 1.2 MB). */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
